import React from 'react'
import {Lang} from 'yougile-lang'
import {cn} from '../../../containers/html-utils'
import {CrmActivitiesFilters, CrmActivitiesView} from '../common'
import {DayFilterComponent} from './day-filter-component'

interface DealViewDateFilterProps {
  filters: CrmActivitiesFilters
  setFilters: (filters: CrmActivitiesFilters) => void
  activitiesView: CrmActivitiesView
}

export const DealViewDateFilter = (props: DealViewDateFilterProps) => {
  const {filters, setFilters, activitiesView} = props
  const titleDay = Lang.msg.crm.activitiesView.tabs.day
  const titleFailed = `${Lang.msg.crm.activitiesView.tabs.failed} (${activitiesView.stats?.failed})`
  const titleCompleted = `${Lang.msg.crm.activitiesView.tabs.completed} (${activitiesView.stats?.completed})`

  return (
    <div className={cn('flex items-center mb-12')}>
      {filters.page === 'day' && (
        <div className="flex items-center gap-16">
          <div className="w-full h2-semibold text-primary min-w-100">
            {titleDay}
          </div>

          <DayFilterComponent
            filters={filters}
            setFilters={setFilters}
            activitiesView={activitiesView}
          />
        </div>
      )}

      {filters.page === 'failed' && (
        <div className="w-full h2-semibold text-primary min-w-100">
          {titleFailed}
        </div>
      )}

      {filters.page === 'completed' && (
        <div className="w-full h2-semibold text-primary min-w-100">
          {titleCompleted}
        </div>
      )}
    </div>
  )
}
